import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms'
import { AutosizeModule } from 'ngx-autosize';
// import {Autosize} from 'ng-autosize';
import { QuestionTitleComponent } from './question-title.component';
import { NgModelOptionsModule } from '../../../shared';

@NgModule({
  imports:[
    CommonModule,
    FormsModule, ReactiveFormsModule, 
    AutosizeModule, 
    // Autosize,
    NgModelOptionsModule// textarea

  ],
  declarations:[QuestionTitleComponent],
  exports:[QuestionTitleComponent]
})
export class QuestionTitleModule { }



